import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { useMemoizedFn } from "ahooks";
import style from "./index.module.less";

export default function Menu() {
  const [current_key, set_key] = useState("add-stake"); // Default active item
  const menu = [
    { label: "Add Stake", key: "add-stake" },
    { label: "Remove Stake", key: "remove-stake" },
  ];
  const location = useLocation(); // 获取当前路径
  const navigate = useNavigate();
  useEffect(() => {
    const path = location.pathname.substring(1) || "add-stake";
    set_key(path);
  }, [location.pathname]);
  const changeRoute = useMemoizedFn((key: string) => {
    set_key(key);
    navigate(`/${key}`);
  });

  return (
    <ul className={style.menu}>
      {menu.map((item) => (
        <li
          key={item.key}
          className={classNames(style.item, {
            [style.active]: item.key === current_key,
          })}
          onClick={() => changeRoute(item.key)}
        >
          {item.label}
        </li>
      ))}
    </ul>
  );
}
